class AppApi {
  public shareWithApp(window: any, text: string): boolean {
    //IOS
    if (AppApi.isShareAPIAvailable(window)) {
      (window.navigator as any).share({
        text: text,
      });
      return true;
    }

    //Android
    if (AppApi.isAndroidShareAPIAvailable(window)) {
      window.Share.postMessage(text);
      return true;
    }

    return false;
  }

  public canShareOnMobile(window: any) {
    return AppApi.isShareAPIAvailable(window) || AppApi.isAndroidShareAPIAvailable(window);
  }

  private static isShareAPIAvailable(window: any): boolean {
    return !!(window.navigator as any).share;
  }

  private static isAndroidShareAPIAvailable(window: any): boolean {
    return window.Share && window.Share.postMessage;
  }
}

export default new AppApi();
